import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import HomePage from './pages/Home';
import ProductsPage from './pages/Products';
import RootLayout from './pages/Root';
import ErrorPage from './pages/Error';
import ProductDetailPage from './pages/ProductDetail';

const router = createBrowserRouter([
  {
    path: '/react-router-basics',
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true, // path: ''
        element: <HomePage />
      },
      {
        path: '/react-router-basics/products',
        element: <ProductsPage />
      },
      {
        path: '/react-router-basics/products/:productId',
        element: <ProductDetailPage />
      }
    ]
  }
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
